import { render } from "./Download.vue?vue&type=template&id=1c058108&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=1c058108&lang=scss&scoped=true"

import exportComponent from "/Users/smzdm/Desktop/前端项目/畅效官网/cx_official_website/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c058108"]])

export default __exports__